export const widthValues = ['xs', 'sm', 'md', 'lg'];
export const SCREEN_WIDTHS = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};
export const REQUEST_METHOD = {GET: 'GET', POST: 'POST', PUT: 'PUT', DELETE: 'DELETE'};

export const HEADER_TYPES = {UNAUTHENTICATED: "un_authenticated", AUTHENTICATED: "authenticated", FOR_AUTHENTICATION: "for_authentication"}